import React from 'react'
import './css/styles.scss'
import { Route, Switch } from 'react-router-dom'
import { withRouter } from 'react-router'
// import * as ROUTES from './constants/routes'
import Page from './components/Page'
import Header from './components/Header'
import Login from './components/Login'
import Dashboard from './components/Dashboard'
import CompetitorView from './components/CompetitorView'
import CompetitorList from './components/CompetitorList'
import ObjectList from './components/ObjectList'
import ObjectEdit from './components/ObjectEdit'
import ArticleResources from './components/ArticleResources'
import ArticleEdit from './components/ArticleEdit'
import ArticleQueries from './components/ArticleQueries'
import SiteView from './components/SiteView'
import SiteList from './components/SiteList'
import SnippetView from './components/SnippetView'
import ArticleView from './components/ArticleView'
import ArticleRedirectImages from './components/ArticleRedirectImages'
import Amazon from './components/Amazon'
import AmazonCrawl from './components/AmazonCrawl'
import AmazonCommissions from './components/AmazonCommissions'
import Inspect from './components/Inspect'
import Clicks from './components/Clicks'
import Menu from './components/Menu'
import Unavailable from './components/Unavailable'
import SearchConsole from './components/SearchConsole'
// import SearchConsoleSite from './components/SearchConsoleSite'
import SearchConsolePage from './components/SearchConsolePage'
import CreateArticleTranslation from './components/CreateArticleTranslation'
import DuplicateArticle from './components/DuplicateArticle'
import Checks from './components/Checks'
import { If } from './modules/helpers'
import { get } from './modules/fetch'

// const website_url = 'https://lighthouse.sistersmile.com'

export let api_token = localStorage.getItem('api_token')

export const configContext = React.createContext({})
export const appContext = React.createContext({})
export const appStateContext = React.createContext({})

const listeners = {}

const resource_article_id = (localStorage.getItem('resource_article_id') !== 'undefined' && localStorage.getItem('resource_article_id')) || undefined

class App extends React.PureComponent {
    state = {
        logged_in: api_token || false,
        config: { endpoint_array: [] },
        alt: false,
        ctrl: false,
        not_available_link_array: [],
        resource_article_id,
    }

    fetchUnavailable = () =>
        new Promise((resolve) => {
            get('provider/amazon/unavailable_links?scope=list')
                // .then(r => r.json())
                .then(
                    (r) =>
                        this.setState({ not_available_link_array: r.sort((a, b) => (a.external_id.localeCompare(b.external_id) && 1) || -1) }, () =>
                            resolve(r)
                        ) || r
                )
            // .then(console.log)
        })

    componentDidMount() {
        // fetch(website_url+'/config/config.json')
        // .then(data => data.json())
        // .then(config => { console.log(config); this.setState({config}); })

        listeners.keydown = document.addEventListener('keydown', (e) => {
            // console.log(e.key)
            if (e && e.key) {
                if (e.key === 'Alt') {
                    console.log('Alt key pressed, setting to', !this.state.alt)
                    this.setState({ alt: !this.state.alt })
                }
                if (e.key === 'Control') {
                    // console.log('Ctrl key pressed')
                    this.setState({ ctrl: true })
                }
                // if ((+e.key).toString() == e.key && e.ctrlKey) {
                //     this.props.select_tab(+e.key)
                //     if (!this.props.display_devtools) this.props.toggle_devtools(!this.props.display_devtools)
                // }
                // if ((e.key == 'd') && e.ctrlKey) {
                //     this.props.toggle_devtools(!this.props.display_devtools)
                // }
            }
        })
        listeners.keyup = document.addEventListener('keyup', (e) => {
            if (e && e.key) {
                // if (e.key === 'Alt') {
                //     console.log('Alt key released')
                //     this.setState({ alt: false })
                // }
                if (e.key === 'Control') {
                    // console.log('Ctrl key released')
                    this.setState({ ctrl: false })
                }
            }
        })
    }
    logOut = () => {
        localStorage.removeItem('api_token')
        this.setState({ logged_in: false })
    }

    render() {
        return (
            <React.Fragment>
                <appContext.Provider value={this}>
                    <appStateContext.Provider value={{ state: this.state, setState: this.setState.bind(this) }}>
                        <configContext.Provider value={this.state.config}>
                            <React.Fragment>
                                {(this.state.logged_in && (
                                    <Header
                                        alt={this.state.alt}
                                        className={((this.state.alt && 'alt-mode') || '') + ((this.state.ctrl && ' ctrl-mode') || '')}
                                    />
                                )) ||
                                    null}
                                {!this.state.logged_in && <Login />}
                                <Page className={'py-3' + ((this.state.alt && ' alt-mode') || '') + ((this.state.ctrl && ' ctrl-mode') || '')}>
                                    <If condition={!!this.state.logged_in}>
                                        <Switch>
                                            <Route exact path={'/checks'} component={Checks} />
                                            <Route exact path={'/:model(article)/:action(edit)/:id'} component={ArticleEdit} />
                                            <Route exact path={'/:model(article)/:action(edit)'} component={ArticleEdit} />
                                            <Route exact path={'/:model(article)/:action(queries)/:id'} component={ArticleQueries} />
                                            <Route exact path={'/:model(article)/:action(redirect-images)/:id'} component={ArticleRedirectImages} />
                                            <Route exact path={'/:model(competitor)/list'} component={CompetitorList} />
                                            <Route exact path={'/:model(site)/list'} component={SiteList} />
                                            <Route exact path={'/:model/list'} component={ObjectList} />
                                            <Route exact path={'/:model/edit'} component={ObjectEdit} />
                                            <Route exact path={'/clicks'} component={Clicks} />
                                            <Route exact path={'/unavailable'} component={Unavailable} />
                                            <Route exact path={'/site/view/:id/search-console'} component={SearchConsole} />
                                            <Route exact path={'/article/view/:id/search-console'} component={SearchConsolePage} />
                                            <Route exact path={'/article/edit/:id/search-console'} component={SearchConsolePage} />
                                            <Route exact path={'/article/translate/:id'} component={CreateArticleTranslation} />
                                            <Route exact path={'/article/duplicate/:id'} component={DuplicateArticle} />
                                            <Route path={'/menu/edit/:id'} component={Menu} />
                                            <Route path={'/:model/edit/:id'} component={ObjectEdit} />
                                            <Route path={'/snippet/view/:id'} component={SnippetView} />
                                            <Route path={'/site/view/:id'} component={SiteView} />
                                            <Route path={'/article/view/:id'} component={ArticleView} />
                                            <Route path={'/competitor/view/:id'} component={CompetitorView} />
                                            <Route exact path={'/provider/amazon/commissions/:node_id?'} component={AmazonCommissions} />
                                            <Route path={'/provider/amazon/crawl/:node_id?'} component={AmazonCrawl} />
                                            <Route exact path={'/provider/amazon/:node_id?/:article_id?'} component={Amazon} />
                                            <Route path={'/resources/:article_id?'} component={ArticleResources} />
                                            <Route path={'/inspect'} component={Inspect} />
                                            <Route exact path={'/'} component={Dashboard} />
                                        </Switch>
                                    </If>
                                </Page>
                            </React.Fragment>
                        </configContext.Provider>
                    </appStateContext.Provider>
                </appContext.Provider>
            </React.Fragment>
        )
    }
}

export default withRouter(App)
